import { supabase } from './supabase';
export class OperationError extends Error {
  constructor(
    public code: string,
    message: string,
    public field?: string,
    public requestId?: string,
  ) {
    super(message);
    this.name = 'OperationError';
  }
}
export function operationsError(value: unknown): OperationError {
  const e = value as {
    code?: string;
    message?: string;
    details?: string;
    error?: { code?: string; message?: string; field?: string; request_id?: string };
  };
  if (typeof e.error?.code === 'string' && typeof e.error?.message === 'string')
    return new OperationError(e.error.code, e.error.message, e.error.field, e.error.request_id);
  if (e.details) {
    try {
      const detail = JSON.parse(e.details)?.error;
      if (typeof detail?.code === 'string' && typeof detail?.message === 'string')
        return new OperationError(
          detail.code,
          detail.message,
          typeof detail.field === 'string' ? detail.field : undefined,
          typeof detail.request_id === 'string' ? detail.request_id : undefined,
        );
    } catch {
      /* Legacy operations keep their existing error transport. */
    }
  }
  if (e.message === 'FORBIDDEN' || e.code === '42501')
    return new OperationError(
      'FORBIDDEN',
      'Your account does not have permission for this action. Refresh access or contact your Super Admin.',
    );
  if (e.code === 'PGRST202' || e.code === '42703')
    return new OperationError(
      'MIGRATION_REQUIRED',
      'The operations database update is required before saving these changes.',
    );
  const match = e.message?.match(/^([A-Z_]+):\s*([\s\S]*)$/);
  return new OperationError(
    match?.[1] || e.code || 'UNKNOWN_RESULT',
    match?.[2] || e.message || 'The result could not be confirmed. Use Recover before retrying.',
  );
}
export async function operationsRpc<T>(
  name: string,
  args: Record<string, unknown> = {},
): Promise<T> {
  const { data, error } = await supabase.rpc(name, args);
  if (error) throw operationsError(error);
  if (data && typeof data === 'object' && 'error' in data) throw operationsError(data);
  return data as T;
}
